import { FC } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import styled from "styled-components";
import closeModal from "src/assets/images/common/closeModal.svg";
import { theme } from "src/styles/Theme";

const Wrapper = styled.div`
	width: 100%;

	.heading {
		margin-bottom: 1rem;
		padding: 0 20px;

		h3 {
			font-weight: 600;
			font-size: 24px;
			line-height: 32px;
			color: ${(props) => props.theme.colors.black};
		}
	}
`;

const style = {
	position: "absolute" as "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 520,
	maxWidth: "90%",
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	alignItems: "center",
	bgcolor: theme.colors.white,
	borderRadius: "8px",
	boxShadow: 24,
	outline: "none",
	p: "10px 0",
};

export const InvoiceModal: FC<{
	open: boolean;
	handleClose: () => void;
	bookingTransaction?: TransactionTypes[];
}> = ({ open, handleClose, bookingTransaction }) => {
	const hasData = bookingTransaction && bookingTransaction.length > 0;
	return (
		<div>
			<Modal
				aria-labelledby='transition-modal-title'
				aria-describedby='transition-modal-description'
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{ timeout: 500 }}
			>
				<Fade in={open}>
					<Box sx={style}>
						<Wrapper>
							<button
								onClick={handleClose}
								style={{ position: "absolute", top: -13, right: -10 }}
							>
								<img src={closeModal} alt='' width={32} height='32px' />
							</button>
							<div className='heading'>
								<div className='flex justify-between items-center'>
									<h3>Invoice</h3>
								</div>
							</div>
							<div className='flex-1 overflow-y-auto px-2 py-2 bg-white'>
								{hasData ? (
									<table className='w-full text-left'>
										<thead>
											<tr className='text-gray-400 text-sm'>
												<th className='font-normal pb-2'>Narration</th>
												<th className='font-normal pb-2'>Amount</th>
												<th className='font-normal pb-2'>Status</th>
											</tr>
										</thead>
										<tbody>
											{bookingTransaction!.map((trx) => (
												<tr key={trx._id}>
													<td className='py-2'>{trx.narration}</td>
													<td className='py-2 font-bold'>
														₦
														{Number(trx.amount).toLocaleString(undefined, {
															minimumFractionDigits: 2,
														})}
													</td>
													<td className='py-2'>{trx.status}</td>
												</tr>
											))}
										</tbody>
									</table>
								) : (
									<div className='text-center text-gray-400 py-8'>
										No invoice transactions available.
									</div>
								)}
							</div>
						</Wrapper>
					</Box>
				</Fade>
			</Modal>
		</div>
	);
};

export default InvoiceModal;
